<div class="page-wrapper">
  <app-modal
    [show]="showDeleteAccountModal() && !!selectedUser()"
    [showBuddy]="false"
    [cycModal]="true"
    (showChange)="showDeleteAccountModal.set($event)"
  >
    <app-delete-user-confirmation
      [title]="deleteUserTitle"
      [message]="deleteUserMessage"
      (confirm)="deleteUser(selectedUser()!)"
    ></app-delete-user-confirmation>
  </app-modal>
  <div class="content-wrapper margin-top">
    <h2 class="ta-center">Manage users</h2>

    <p>Find and promote other users to the role of admin.</p>

    <form class="form" [formGroup]="form">
      <div class="lookup-container residence-lookup-container">
        <input
          type="text"
          class="lookup"
          formControlName="search"
          placeholder="Search users by email, first or last name"
          [class.searching]="searchState() === 'new'"
          (blur)="onSearchBlur()"
        />
        <div class="spinner" *ngIf="searchState() === 'new'"></div>
        <p *ngIf="lookupError()">There was an error searching for this user.</p>
      </div>
    </form>

    <ng-container *ngIf="results().length && !(searchState() === 'new')">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Roles</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of results()">
            <td>
              {{ result.firstName | titlecase }}
              {{ result.lastName | titlecase }}
            </td>
            <td>{{ result.email }}</td>
            <td>
              <div *ngFor="let role of result.roles">
                <span>{{ role.name | titlecase }}</span>
              </div>
            </td>
            <td class="right">
              <button
                class="table-action"
                mat-icon-button
                [mat-menu-trigger-for]="userOptions"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #userOptions>
                <ng-container *ngIf="result.hasRole('admin')">
                  <button
                    mat-menu-item
                    class="menu-item"
                    (click)="removeRole(result, 'admin')"
                  >
                    <mat-icon>remove</mat-icon>
                    <span>Remove admin role</span>
                  </button>
                </ng-container>
                <ng-container *ngIf="!result.hasRole('admin')">
                  <button
                    mat-menu-item
                    class="menu-item"
                    (click)="addRole(result, 'admin')"
                  >
                    <mat-icon>keyboard_double_arrow_up</mat-icon>
                    <span>Make admin</span>
                  </button>
                </ng-container>
                <!-- Delete user account -->
                <button
                  mat-menu-item
                  class="menu-item"
                  (click)="toggleDeleteModal(result)"
                >
                  <mat-icon>delete</mat-icon>
                  <span>Delete user</span>
                </button>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
    <div *ngIf="(moreAvailableUsers().visible) && (!searchState())" class="load-more-cnt">
      <button (click)="search(true)">
        Load more
      </button>
    </div>

    <ng-container *ngIf="searchState()">
      <div class="table-spinner-container">
        <div class="table-spinner"></div>
      </div>
    </ng-container>
  </div>
</div>
